import type {ListCustomerOffersSearchInput} from "./list-customer-offers.schema";
import {listCustomerOffers} from "@project/sdk/sales";
import {ListCustomerOffersResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {customerOfferKeys} from "../../../customerOffer-keys";
import {assertCustomerOfferDocument} from "../../../customerOffer-read";
import {listCustomerOffersSearchSchema} from "./list-customer-offers.schema";

export function listCustomerOffersQueryOptions(rawInput: ListCustomerOffersSearchInput) {
  const params = listCustomerOffersSearchSchema.parse(rawInput);
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: customerOfferKeys.list(params),
    queryFn: async ({signal}) => {
      const response = await listCustomerOffers(params, {signal});
      const parsed = ListCustomerOffersResponse.parse(response);
      parsed.items.forEach((item, index) =>
        assertCustomerOfferDocument(item, response.items[index]),
      );
      return parsed;
    },
  });
}
